<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "权限不足",
      items: [
        {
          text: "错误",
          active: true,
        },
      ],
    };
  },
  computed: {
    fromPath() {
      return this.$route.query.from || '/';
    },
    requiredPermission() {
      return this.$route.query.permission || '';
    }
  },
  methods: {
    goBack() {
      if (this.fromPath && this.fromPath !== '/') {
        this.$router.push(this.fromPath);
      } else {
        this.$router.push('/');
      }
    },
    goHome() {
      this.$router.push('/');
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body text-center">
            <el-result
              icon="error"
              title="权限不足"
              subTitle="您没有访问此页面的权限"
            >
              <template slot="extra">
                <div class="mb-3">
                  <p class="text-muted">
                    <i class="ri-information-line me-2"></i>
                    所需权限: <code>{{ requiredPermission }}</code>
                  </p>
                  <p class="text-muted">
                    <i class="ri-arrow-left-line me-2"></i>
                    来源页面: <code>{{ fromPath }}</code>
                  </p>
                </div>
                <div>
                  <el-button type="primary" @click="goBack">
                    <i class="ri-arrow-left-line me-1"></i>
                    返回上一页
                  </el-button>
                  <el-button @click="goHome">
                    <i class="ri-home-line me-1"></i>
                    返回首页
                  </el-button>
                </div>
              </template>
            </el-result>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.el-result {
  padding: 2rem 0;
}

code {
  background-color: #f8f9fa;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: #e83e8c;
}
</style>
